import { MODAL_PUBLISH } from '@components/App/Modal/constants'
import { publishResponseAdapter } from '@components/ArtBoard/Publish/helper'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { type ArtBoardMode, artBoardActions } from '@store/reducers/artboard'
import { PublishStatus, setPublishData } from '@storeOld/reducers/publish'
import { openModal } from '@storeOld/reducers/ui'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import { notifyAiStillWorkingBlocked } from '@/hooks/ai/actionCreators'
import { useAiGenerating } from '@/hooks/selectors/useAiGenerating'
import { getPublishProject } from '@/services/project'

export const usePublishButton = () => {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const aiGenerating = useAiGenerating()

  const { publish } = useArtboardMode()
  const published = useSelector(migrationProjectSelector.getPublish)
  const id = useSelector(migrationProjectSelector.getProjectId)

  const projectIsPublished = published?.status === PublishStatus.PUBLISHED

  useEffect(() => {
    if (!id) {
      return
    }

    const fetchPublishProject = async () => {
      try {
        setLoading(true)
        const response = await getPublishProject(id)

        if (response) {
          dispatch(setPublishData(publishResponseAdapter(response)))
        } else {
          dispatch(setPublishData(null))
        }
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    }

    fetchPublishProject()
  }, [])

  const handleClick = () => {
    if (loading) {
      return
    }

    // Don't let the user publish mid-turn — the assistant may still be changing
    // the project (OCT-4826). Tell them and bail.
    if (aiGenerating) {
      dispatch(notifyAiStillWorkingBlocked())

      return
    }

    if (projectIsPublished) {
      const mode: ArtBoardMode = publish ? 'edit' : 'publish'

      dispatch(artBoardActions.changeMode(mode))

      return
    }

    dispatch(openModal(MODAL_PUBLISH))
  }

  return {
    projectIsPublished,
    isActive: publish,
    handleClick,
  }
}
